// Plain-English labels for research_priority_v1 / next_research_action_v1 (single source of truth).
export const PRIORITY_LABEL = {
  P0_ACTION_REQUIRED: "P0 · Action required",
  P1_RESEARCH_NOW: "P1 · Research now",
  P2_WATCH_CLOSELY: "P2 · Watch closely",
  P3_CONTINUE_MONITORING: "P3 · Continue monitoring",
  P4_NO_CURRENT_ACTION: "P4 · No action now",
};

export const PRIORITY_CLS = {
  P0_ACTION_REQUIRED: "text-rose-200 bg-rose-500/15 border-rose-400/45",
  P1_RESEARCH_NOW: "text-emerald-200 bg-emerald-500/15 border-emerald-400/40",
  P2_WATCH_CLOSELY: "text-amber-200 bg-amber-500/15 border-amber-400/40",
  P3_CONTINUE_MONITORING: "text-sky-200 bg-sky-500/12 border-sky-400/30",
  P4_NO_CURRENT_ACTION: "text-zinc-300 bg-zinc-500/10 border-zinc-500/30",
};

export const ACTION_LABEL = {
  RESOLVE_GROUPING: "Review grouping",
  RESOLVE_ENTITY_MATCH: "Resolve product match",
  REVIEW_PRODUCT_IDENTITY: "Review product identity",
  CHECK_GOOGLE_SEARCH: "Check Google Search",
  REVIEW_SUBTYPE: "Review subtype",
  CONTINUE_AMAZON_COLLECTION: "Keep collecting",
  BEGIN_COMMERCIAL_RESEARCH: "Begin commercial research",
  CHECK_COMPETITORS: "Check competitors",
  CHECK_AD_ACTIVITY: "Check advertising activity",
  CHECK_CUSTOMER_PAIN: "Check customer problems",
  CHECK_SOURCEABILITY: "Check if we can source it",
  COMPLETE_ECONOMICS: "Model the numbers",
  REVIEW_DIFFERENTIATION: "Decide what version we should build",
  REVIEW_RISK: "Check risks before going further",
  REVIEW_CAPITAL: "Review this opportunity for a possible controlled test",
  REFRESH_REQUIRED_EVIDENCE: "Refresh evidence",
  NO_ACTION_REQUIRED: "No action",
};

export const AREA_LABEL = {
  search_confirmation: "Search confirmation", social: "Social", competitors: "Competitors",
  ads: "Ads", customer_pain: "Customer pain", sourceability: "Sourceability",
  economics: "Economics", differentiation: "Differentiation", risk: "Risk",
};

export const conceptName = (id) => (id || "").replace(/^concept:/, "").replace(/_/g, " ");
